import { Observable } from "rxjs"

import { ObservableFromFetch } from "../ObservableFromFetch"

export interface PoolSelectionCancel {
  PoolSelectionID: number
}

export interface PoolSelectionRerun {
  PoolSelectionID: number
  RequiredDrug: number
  RequiredAlcohol: number
  AlternateDrug: number
  AlternateAlcohol: number
  ExtraDrug: number
  ExtraAlcohol: number
  AccountID: number
}

export interface PoolSelectionTestMatch {
  TestDetailID: number
  CompletedTestDetailID: number
  HasError: boolean
}

export interface CompletedMatchingTest {
  TestEventID: number
  TestDetailID: number
  PersonID: number
  CCFID: string
  Company: string
  Location: string
  CCFFirstName: string
  CCFLastName: string
  Reason: string
  ReasonDescription: string
  Regulated: string
  SampleType: string
  DateOrdered: string
  FormFoxTestAN: string
  SampleID: string
  HasError: boolean
}

export interface CompletedTestsGridOptions {
  search: {
    field: string
    text: string
  }
  TestDetailID: number
  TestTypeID: number
  PoolSelectionID: number
  PageNumber: number
  PageSize: number
}

export interface CompletedTestsGridData {
  Records: CompletedMatchingTest[]
  Pages: number
  Total: number
}

export function PoolSelectionCancelObservable(poolSelection: PoolSelectionCancel): Observable<string> {
  const params: string = JSON.stringify({
    PoolSelectionID: poolSelection.PoolSelectionID,
  })
  return ObservableFromFetch<string>("WorkforceRandomTest/PoolSelectionCancel", params)
}

export function PoolSelectionRerunObservable(poolSelection: PoolSelectionRerun): Observable<string> {
  const params: string = JSON.stringify({
    PoolSelectionID: poolSelection.PoolSelectionID,
    RequiredDrug: poolSelection.RequiredDrug,
    RequiredAlcohol: poolSelection.RequiredAlcohol,
    AlternateDrug: poolSelection.AlternateDrug,
    AlternateAlcohol: poolSelection.AlternateAlcohol,
    ExtraDrug: poolSelection.ExtraDrug,
    ExtraAlcohol: poolSelection.ExtraAlcohol,
  })
  return ObservableFromFetch<string>("WorkforceRandomTest/PoolSelectionRerun", params)
}

export function GetCompletedTestsObservable(options: CompletedTestsGridOptions) {
  const requestBody: string = JSON.stringify(options)
  return ObservableFromFetch<CompletedTestsGridData>("WorkforceRandomTest/GetCompletedTests", requestBody)
}

export function PoolSelectionTestMatchObservable(poolSelectionMatch: PoolSelectionTestMatch) {
  const params: string = JSON.stringify(poolSelectionMatch)
  return ObservableFromFetch<string>("WorkforceRandomTest/PoolSelectionTestMatch", params)
}